export const TARTIB_CLASSNAME = 'tartib';
export const ITEM_CLASSNAME = 'tartib__item';
export const ITEM_SELECTOR = '.' + ITEM_CLASSNAME;
export const ITEM_DRAGGED_CLASSNAME = ITEM_CLASSNAME + '--dragged';
export const PLACEHOLDER_CLASSNAME = 'tartib__placeholder';
export const ELEVATION_CLASSNAME = 'tt-elevation';
export const ACTIVE_CLASSNAME = 'tt-active';